import { Inject, Injectable, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Globals
import { GlobalsService, SERVER_URL } from './globals.service';
import { StorageService } from './storage.service';
import { ViasAlertService } from './vias-alert.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ViasUserPrefService } from './vias-user-pref.service';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

export interface ViasResponse {
  sid: string;
  pid: number;
  aid: number;
  return_action: string;
  error: string[];
  perm: string;
  permission: boolean[];
  data: object;
}

export enum ViasReturnActions {
  Close = 'close',
  Success = 'success',
  RefreshSelf = 'refresh_self',
  RefreshParent = 'refresh_parent',
  RefreshAndClose = 'refreshAndClose',
  RefreshWorkDone = 'refresh_work_done',
  RefreshPPL = 'refresh_ppl',
  RefreshFPL = 'refresh_fpl',
}


@Injectable({
  providedIn: 'root'
})
export class ViasConnectionService {

  constructor(@Inject(SERVER_URL) public serverUrl, private http: HttpClient) {
  }
  public progressSpinnerRun: boolean = false;
  public send(pid: number, aid: number, data: object, url: string = this.serverUrl): Promise<ViasResponse> {
    console.log(url);
    console.log(JSON.stringify(data));
    this.progressSpinnerRun = true;
    return new Promise((resolve, reject) => {
      let debugStr = 'json= 1&';
      debugStr += 'pid=' + pid.toString() + '&';
      debugStr += 'aid=' + aid.toString() + '&';
      debugStr += 'data=' + JSON.stringify(data);
      const params: FormData = new FormData();
      params.append('json', '1');
      params.append('pid', pid.toString());
      params.append('aid', aid.toString());
      params.append('data', JSON.stringify(data));
      console.log(params);
      this.http.post(url, params, { withCredentials: true })
        .toPromise()
        .then(
          res => {
            this.progressSpinnerRun = false;
            resolve(res as ViasResponse);
          },
          err => {
            this.progressSpinnerRun = false;
            reject(err);
          }
        )
        .catch(err => {
          this.progressSpinnerRun = false;
          reject(err);
        });
    });
  }

  public uploadFile(pid: number, aid: number, data: object, file: File, fileName: string = 'fileData',
                    relatedPid?: string, relatedId?: string, relatedId2?: string, removeOldFiles?: string): Observable<any> {
    console.log(file);
    console.log(JSON.stringify(data));
    this.progressSpinnerRun = true;
    //   this.serverUrl = 'https://file.io';
    const params = new FormData();
    params.append('json', '1');
    params.append('pid', pid.toString());
    params.append('aid', aid.toString());
    params.append('data', JSON.stringify(data));
    params.append('related_pid', relatedPid);
    params.append('related_id', relatedId);
    params.append('related_id2', relatedId2);
    params.append('remove_old_files', removeOldFiles);// 1 eski dosyayı siler
    // files.forEach(file => {
    params.append(fileName, file, file.name);
    // });
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'multipart/form-data');
    return this.http.post<any>(this.serverUrl, params, {
      withCredentials: true,
      reportProgress: true,
      observe: 'events',
      headers
    })
    .pipe(
      tap(_ => this.progressSpinnerRun = false ),
      catchError(val => { 
        this.progressSpinnerRun = false;
        console.log(val); 
        return val; })
    );
  }
  public downloadFile(pid: number, aid: number, data: object, fileName: string = '', url: string = this.serverUrl): void {
      const params: FormData = new FormData();
      params.append('json', '1');
      params.append('pid', pid.toString());
      params.append('aid', aid.toString());
      params.append('data', JSON.stringify(data));
      console.log(params);
      this.progressSpinnerRun = true;
      if(fileName === ''){
        fileName = new Date().toLocaleDateString();
      }
      this.http.post(this.serverUrl, params, { withCredentials: true, responseType: 'blob' })
        .toPromise()
        .then(
          res => {
            this.progressSpinnerRun = false;
            var newFile = document.createElement("a");
            newFile.href = URL.createObjectURL(res);
            newFile.download = fileName;
            // start download
            newFile.click();
          }
        ).catch(err => {
            this.progressSpinnerRun = false;
        });
  }
}
